import * as React from 'react';

const BenefitIcon: React.FC<React.SVGProps<SVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26"
    height="26"
    fill="none"
    viewBox="0 0 26 26"
  >
    <path
      fill="url(#paint0_linear_2073_618)"
      d="M5.254 7.98A2.31 2.31 0 0 1 7.41 6.5h12.387a2.31 2.31 0 0 1 2.066 1.277l.97 1.941a2.31 2.31 0 0 1-.343 2.572l-6.922 7.753a2.31 2.31 0 0 1-3.387.063l-7.263-7.542a2.31 2.31 0 0 1-.492-2.431z"
    ></path>
    <path
      stroke="url(#paint1_linear_2073_618)"
      strokeWidth="0.513"
      d="M6.149 11.631c1.925 3.005 5.543 7.185 7.285 8.885"
    ></path>
    <path
      stroke="url(#paint2_linear_2073_618)"
      strokeWidth="0.513"
      d="M7.888 6.663c-1.094 1.742-1.893 3.483-1.745 5.005"
    ></path>
    <path
      stroke="url(#paint3_linear_2073_618)"
      strokeWidth="0.513"
      d="M19.311 6.653c1.094 1.743 1.893 3.483 1.746 5.006"
    ></path>
    <path
      stroke="url(#paint4_linear_2073_618)"
      strokeWidth="0.513"
      d="M13.961 6.655c1.094 1.743 1.063 5.094-.255 14.015"
    ></path>
    <path
      stroke="url(#paint5_linear_2073_618)"
      strokeWidth="0.513"
      d="M21.086 11.714c-1.925 3.004-5.377 7.206-7.12 8.906"
    ></path>
    <path
      stroke="url(#paint6_linear_2073_618)"
      strokeLinecap="round"
      strokeWidth="0.513"
      d="M4.637 11.252c4.893 1.344 13.463 1.352 18.12-.005"
    ></path>
    <defs>
      <linearGradient
        id="paint0_linear_2073_618"
        x1="13.716"
        x2="13.716"
        y1="6.5"
        y2="21.901"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.305" stopColor="#FFC000"></stop>
        <stop offset="1" stopColor="#CC00A7"></stop>
      </linearGradient>
      <linearGradient
        id="paint1_linear_2073_618"
        x1="13.12"
        x2="6.858"
        y1="18.653"
        y2="11.053"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D72983"></stop>
        <stop offset="1" stopColor="#E2576D"></stop>
      </linearGradient>
      <linearGradient
        id="paint2_linear_2073_618"
        x1="4.374"
        x2="7.531"
        y1="11.669"
        y2="6.925"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D72983"></stop>
        <stop offset="1" stopColor="#FDC435"></stop>
      </linearGradient>
      <linearGradient
        id="paint3_linear_2073_618"
        x1="22.825"
        x2="19.668"
        y1="11.659"
        y2="6.915"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FCDDB5"></stop>
        <stop offset="1" stopColor="#FDC435"></stop>
      </linearGradient>
      <linearGradient
        id="paint4_linear_2073_618"
        x1="13.996"
        x2="14.479"
        y1="20.367"
        y2="6.655"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D72983"></stop>
        <stop offset="0.818" stopColor="#FFDD86"></stop>
        <stop offset="1" stopColor="#FFC001"></stop>
      </linearGradient>
      <linearGradient
        id="paint5_linear_2073_618"
        x1="14.047"
        x2="21.777"
        y1="20.896"
        y2="11.889"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D72983"></stop>
        <stop offset="1" stopColor="#FEE8B8"></stop>
      </linearGradient>
      <linearGradient
        id="paint6_linear_2073_618"
        x1="4.992"
        x2="22.757"
        y1="11.414"
        y2="11.414"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D72983"></stop>
        <stop offset="0.91" stopColor="#FFEBB9"></stop>
        <stop offset="1" stopColor="#FCB40B"></stop>
      </linearGradient>
    </defs>
  </svg>
);

export default BenefitIcon;
